<template>
  <v-container>
    <v-row class="justify-center d-flex mt-n16">
      <v-col lg="4" md="7" class="mx-auto">
        <v-card class="card-shadow border-radius-xl">
          <div class="card-padding text-center">
            <h5 class="text-h5 text-typo font-weight-bold">Create your account</h5>
          </div>
          <div class="card-padding">
            <v-text-field
              v-model="name"
              hide-details
              outlined
              background-color="rgba(255,255,255,.9)"
              color="rgba(0,0,0,.6)"
              light
              height="40"
              placeholder="Name"
              autocomplete="name"
              :class="inputClass"
            >
            </v-text-field>

            <v-text-field
              v-model="email"
              hide-details
              outlined
              background-color="rgba(255,255,255,.9)"
              color="rgba(0,0,0,.6)"
              light
              height="40"
              placeholder="Email"
              autocomplete="email"
              :class="inputClass"
            >
            </v-text-field>

            <v-text-field
              v-model="password"
              type="password"
              hide-details
              outlined
              background-color="rgba(255,255,255,.9)"
              color="rgba(0,0,0,.6)"
              light
              height="40"
              placeholder="Password"
              autocomplete="new-password"
              @keyup.enter="register()"
              :class="inputClass"
            >
            </v-text-field>
            <p class="text-xs text-body mt-n2 mb-2">
              At least 8 characters, with upper and lower case letters, a number and a symbol.
            </p>

            <v-checkbox
              v-model="checkbox"
              color="#141727"
              :ripple="false"
              class="ma-0 checkbox-custom checkbox-thinner"
              hide-details
            >
              <template v-slot:label>
                <span class="text-typo text-body-2 ls-0"
                  >I agree the
                  <a
                    href="javascript:;"
                    class="text-dark font-weight-bolder text-decoration-none"
                    >Terms and Conditions</a
                  ></span
                >
              </template>
            </v-checkbox>

            <p v-if="errorMessage" class="text-sm text-danger mt-2 mb-0">{{ errorMessage }}</p>

            <v-btn
              @click.prevent="register()"
              :loading="loading"
              :disabled="!checkbox"
              elevation="0"
              :ripple="false"
              height="43"
              class="
                font-weight-bold
                text-uppercase
                btn-default
                bg-gradient-default
                py-2
                px-6
                me-2
                mt-6
                mb-2
                w-100
              "
              color="#5e72e4"
              small
              >Sign Up</v-btn
            >
            <p class="text-sm text-body mt-3 mb-0">
              Already have an account?
              <a
                href="#/pages/authentication/login"
                class="text-dark text-decoration-none font-weight-bolder"
                >Sign in</a
              >
            </p>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import { signUp, authErrorMessage } from '@/auth/cognito'

  export default {
    name: 'sign-up-basic',
    data() {
      return {
        name: '',
        email: '',
        password: '',
        checkbox: false,
        loading: false,
        errorMessage: '',
        inputClass: 'input-style font-size-input border border-radius-md placeholder-lighter text-color-light mb-4',
      }
    },
    methods: {
      async register() {
        if (this.loading || !this.checkbox) return
        this.errorMessage = ''
        this.loading = true
        try {
          const result = await signUp({ name: this.name, email: this.email, password: this.password })
          this.$router.push({ path: result.confirmed ? '/pages/authentication/login' : '/pages/authentication/confirm' })
        } catch (error) {
          this.consoleLog('error', 'SignUp/Basic.vue fn(register): error catch', error)
          this.errorMessage = authErrorMessage(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
